import loader from '../img/gifs/dietlyLoader.gif';

const Loader = ({ path }) => {
  return (
    <div className="menu-widget-catering-menu__loader">
      <div
        className="menu-widget-catering-menu__loader-img"
        style={{
          backgroundImage: `url(${(path && path + loader) || loader})`,
        }}
      />
      <span className="menu-widget-catering-menu__loader-text--loading">
        Ładowanie menu...
      </span>
    </div>
  );
};

export default Loader;
